// extracted by mini-css-extract-plugin
module.exports = {"dialogPaper":"style_dialogPaper__rR0rD","wrapper":"style_wrapper__keoMs","gift":"style_gift__1NGaT","closeIcon":"style_closeIcon__3_k3G","content":"style_content__3UDou"};